import { ReactSkeleton } from '@approvalmax/ui';
import { FC, memo } from 'react';

import { Item, Root } from './Skeleton.styles';

const Skeleton: FC = memo(() => {
    return (
        <Root>
            <Item>
                <ReactSkeleton height={27} />
            </Item>

            <Item>
                <ReactSkeleton height={27} />
            </Item>

            <Item>
                <ReactSkeleton height={27} />
            </Item>
        </Root>
    );
});

export default Skeleton;
